(function () {
  'use strict';

  var TOUR_SELECTOR = '[data-bandsintown-tour]';
  var EVENT_SELECTOR = '[data-test="event-card"], .bit-event, .bit-upcoming-events-list-item';
  var WIDGET_SRC = 'https://widget.bandsintown.com/main.min.js';

  function enhanceCard(card) {
    var dateEl = card.querySelector('[data-test="date"], .bit-date, .bit-event__date, time');
    var venueEl = card.querySelector('[data-test="venue-name"], .bit-venue, .bit-event__venue, [itemprop="name"]');
    var cityEl = card.querySelector('[data-test="location"], .bit-location, .bit-event__location, [itemprop="addressLocality"]');

    var date = ((dateEl && (dateEl.getAttribute('datetime') || dateEl.textContent || '')) || '').trim();
    var venue = ((venueEl && venueEl.textContent) || '').trim();
    var city = ((cityEl && cityEl.textContent) || '').trim();

    card.querySelectorAll('a, button').forEach(function (link) {
      var text = (link.textContent || '').trim().toLowerCase();
      var className = typeof link.className === 'string' ? link.className : '';
      var isTickets =
        text === 'tickets' ||
        text === 'buy tickets' ||
        link.classList.contains('bit-tickets-button') ||
        className.indexOf('tickets') !== -1;
      var isRsvp =
        text === 'rsvp' ||
        link.classList.contains('bit-rsvp-button') ||
        className.indexOf('rsvp') !== -1;

      if (!isTickets && !isRsvp) return;

      var label = (isTickets ? 'Tickets' : 'RSVP') +
        (date ? ' for ' + date : '') +
        (venue ? ' at ' + venue : '') +
        (city ? ' in ' + city : '');

      link.setAttribute('aria-label', label);

      var hidden = link.querySelector('[data-bandsintown-label]');
      if (!hidden) {
        hidden = document.createElement('span');
        hidden.className = 'sr-only';
        hidden.setAttribute('data-bandsintown-label', '');
        link.appendChild(hidden);
      }
      hidden.textContent = ' — ' + label;

      if (link.target === '_blank') {
        var rel = (link.rel || '').split(/\s+/).filter(Boolean);
        if (rel.indexOf('noopener') === -1) rel.push('noopener');
        if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
        link.rel = rel.join(' ');
      }
    });
  }

  function enhanceTour(root) {
    if (root.matches && root.matches(EVENT_SELECTOR)) enhanceCard(root);
    root.querySelectorAll(EVENT_SELECTOR).forEach(enhanceCard);
  }

  function loadWidget(tour) {
    if (tour.getAttribute('data-bandsintown-requested') === 'true') return;
    tour.setAttribute('data-bandsintown-requested', 'true');

    window.BIT = window.BIT || {};
    window.BIT.Config = window.BIT.Config || {};
    window.BIT.Config.appId = 'js_concordjazz.myshopify.com';
    window.BIT.Config.affilCode = 'js_concordjazz.myshopify.com';

    var widgetScript = document.querySelector('script[data-bandsintown-widget]');
    var shouldAppend = false;
    if (!widgetScript) {
      widgetScript = document.createElement('script');
      widgetScript.async = true;
      widgetScript.charset = 'utf-8';
      widgetScript.src = WIDGET_SRC;
      widgetScript.setAttribute('data-bandsintown-widget', '');
      shouldAppend = true;
    }

    if (widgetScript.getAttribute('data-loaded') === 'true') {
      enhanceTour(tour);
      return;
    }

    widgetScript.addEventListener('load', function () {
      widgetScript.setAttribute('data-loaded', 'true');
      enhanceTour(tour);
    }, { once: true });

    if (shouldAppend) document.head.appendChild(widgetScript);
  }

  function initTour(tour) {
    if (tour.getAttribute('data-bandsintown-initialized') === 'true') return;
    tour.setAttribute('data-bandsintown-initialized', 'true');

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) enhanceTour(node);
        });
      });
    });
    observer.observe(tour, { childList: true, subtree: true });

    if ('IntersectionObserver' in window) {
      var intersectionObserver = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        intersectionObserver.disconnect();
        loadWidget(tour);
      }, { rootMargin: '500px 0px' });
      intersectionObserver.observe(tour);
      return;
    }

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(function () { loadWidget(tour); }, { timeout: 2000 });
    } else {
      window.setTimeout(function () { loadWidget(tour); }, 0);
    }
  }

  function initTours(root) {
    if (root.matches && root.matches(TOUR_SELECTOR)) initTour(root);
    root.querySelectorAll(TOUR_SELECTOR).forEach(initTour);
  }

  initTours(document);

  document.addEventListener('shopify:section:load', function (event) {
    initTours(event.target);
  });
})();
